module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lmU0o"))).then(() => parcelRequire('fThBo'));